import { Maybe } from '@iss/libs/graphql';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

import { IconComponent, IconName } from '@iss/core/icon';

@Component({
  selector: 'iss-content-panel',
  templateUrl: './content-panel.component.html',
  styleUrls: [ './content-panel.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconComponent,
    NgIf,
  ],
})
export class ContentPanelComponent {
  @Input() title: Maybe<string>;
  @Input() icon: Maybe<IconName>;
  @Input() hideHeader: Maybe<boolean>;
  @Input() hideButtons: Maybe<boolean>;
}
